import {
  Grid,
  Typography,
  CardContent,
  Card,
  Box,
  Divider,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  SelectInput,
  TextInput,
  NumberInput,
  ArrayInput,
  SimpleFormIterator,
  required,
} from "react-admin";
import { IfCanAccess } from "@react-admin/ra-rbac";
import AnimatedBlock from '../../../components/Common/AnimatedBlock';
import FormField from '../../../components/Common/FormField';

const currencyChoices = [
  { id: 'ETH', name: 'ETH' },
  { id: 'POL', name: 'POL' },
  { id: 'MATIC', name: 'MATIC' },
  { id: 'XTZ', name: 'XTZ' },
];

const destinationModeChoices = [
  { id: 'whitelist', name: 'Whitelist' },
  { id: 'free', name: 'Free' },
];

const SectionTitle = ({ title, subtitle }: { title: string; subtitle: string }) => (
  <Box pb={2}>
    <Typography variant="h6">{title}</Typography>
    <Typography variant="body2" color="text.secondary">
      {subtitle}
    </Typography>
  </Box>
);

function ParametersGasStationTabCreate() {
  const { t }: { t: any } = useTranslation();
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <SectionTitle title={t("Gas station configuration")} subtitle={t("Currency, limits and destination rules of this gas station")} />
        <AnimatedBlock>
          <Card sx={{ mb: 3 }}>
            <CardContent
              sx={{
                p: 4
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormField label={t('Currency')}>
                    <SelectInput
                      source="parameters.gasStation.currency"
                      label={false}
                      fullWidth
                      choices={currencyChoices}
                      validate={required()}
                    />
                  </FormField>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormField label={t('Volume available per 24 hours')}>
                    <NumberInput
                      source="parameters.gasStation.limitPer24H"
                      label={false}
                      fullWidth
                      validate={required()}
                    />
                  </FormField>
                </Grid>

                <Grid item xs={12}>
                  <FormField label={t('Webhook URL')}>
                    <TextInput
                      source="parameters.webhookUrl"
                      label={false}
                      fullWidth
                    />
                  </FormField>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormField label={t('Approval threshold (EUR)')}>
                    <NumberInput
                      source="parameters.gasStation.approvalThresholdEur"
                      label={false}
                      fullWidth
                    />
                  </FormField>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormField label={t('Commission rate')}>
                    <NumberInput
                      source="parameters.gasStation.commissionRate"
                      label={false}
                      fullWidth
                    />
                  </FormField>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormField label={t('Destination mode')}>
                    <SelectInput fullWidth
                      source="parameters.gasStation.destinationMode"
                      label={false}
                      choices={destinationModeChoices}
                    />
                  </FormField>
                </Grid>

                <Grid item xs={12}>
                  <FormField label={t('Allowed addresses')}>
                    <ArrayInput source="parameters.gasStation.allowedAddresses" label={false}>
                      <SimpleFormIterator inline>
                        <TextInput source="" label={t('Address')} helperText={false} />
                      </SimpleFormIterator>
                    </ArrayInput>
                  </FormField>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </AnimatedBlock>
        <IfCanAccess resource="projects.userIdCNHS" action="create">
          <SectionTitle title={t("Coinhouse configuration")} subtitle={t("The Coinhouse user this entity is linked to")} />
        <AnimatedBlock>
          <Card sx={{ mb: 3 }}>
              <CardContent
                sx={{
                  p: 4,
                }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <FormField label={t("Coinhouse user UUID")}>
                      <TextInput
                        source="userIdCNHS"
                        sx={{ "& input": { fontFamily: "monospace" } }}
                        label={t("Coinhouse user UUID")}
                        fullWidth
                      />
                    </FormField>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </AnimatedBlock>
        </IfCanAccess>
      </Grid>
    </Grid>
  );
}

export default ParametersGasStationTabCreate;
